<button [matMenuTriggerFor]="applicationsMenu"
        fxHide fxShow.gt-xs mat-icon-button
        matTooltip="Acesso aos módulos do sistema">
    <mat-icon class="secondary-text">apps</mat-icon>
</button>
<mat-menu #applicationsMenu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item (click)="goToApplication(appPortal)">
        <span fxLayout="row" fxLayoutAlign="start center">
                <img [src]="appPortal.attributes.get('icon')" alt="image" class="app-img">
                <span class="iso app-name">{{appPortal.name}}</span>
            </span>
    </button>
    <mat-divider></mat-divider>
    <button (click)="goToApplication(app)" *ngFor="let app of applications" mat-menu-item>
         <span fxLayout="row" fxLayoutAlign="start center">
                 <img [src]="getAppPhoto(app)" alt="image" class="app-img">
                 <span class="iso app-name">{{app.name}}</span>
             </span>
    </button>
</mat-menu>
